import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

const Tab = styled.div`
  height: 3.125rem;
  font-size: 1.0625rem;
  line-height: 3.125rem;
  text-align: center;
  padding: 0 1.875rem;
  color: #0e60c9;
  transition: border-color 200ms;
  border-bottom: solid 4px transparent;
  cursor: pointer;
  flex-basis: 15%;

  &:hover {
    color: #0b4fa5;
  }

  ${({ active }) =>
    active &&
    `
    border-bottom-color: #0e60c9;
    color: ${color.CHARCOAL};

    &:hover {
      color: ${color.CHARCOAL};
    }
  `}
`

export default Tab
